var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('ABreadcrumbV1',{attrs:{"items":_vm.breadcrumbs}}),_c('PageLink',{attrs:{"url":((_vm.$api.servers.game) + "/api/v1/en/moderator/user/linkWithPlayer"),"self":_vm.self,"callbackSuccess":_vm.callbackSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }